// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Modal$OrcaPaymentPage from "../Components/Modal.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "../Hooks/UtilityHooks.bs.js";

function ThreeDSRedirectionModal(props) {
  var match = React.useState(function () {
        return "";
      });
  var setPopupUrl = match[1];
  var match$1 = React.useState(function () {
        return "";
      });
  var setRedirectResponseUrl = match$1[1];
  var redirectResponseUrl = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var match$3 = React.useState(function () {
        return false;
      });
  var setloader = match$3[1];
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var eventsToSendToParent = ["openurl_if_required"];
  UtilityHooks$OrcaPaymentPage.useSendEventsToParent(eventsToSendToParent);
  var handleOnClose = function () {
    if (redirectResponseUrl === "") {
      Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
              "fullscreen",
              false
            ]]);
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("error", "Something went wrong.");
    }
    var customEvent = Utils$OrcaPaymentPage.getDictFromJson({
          openurl_if_required: redirectResponseUrl
        });
    Utils$OrcaPaymentPage.messageParentWindow(undefined, Object.entries(customEvent));
  };
  React.useEffect((function () {
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "iframeMountedCallback",
                  true
                ]]);
          setloader(function (param) {
                return true;
              });
          var handle = function (ev) {
            try {
              var json = Utils$OrcaPaymentPage.safeParse(ev.data);
              var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
              if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
                return ;
              }
              var metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
              var metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
              var popupUrl = Utils$OrcaPaymentPage.getString(metaDataDict, "popupUrl", "");
              var redirectResponseUrl = Utils$OrcaPaymentPage.getString(metaDataDict, "redirectResponseUrl", "");
              setPopupUrl(function (param) {
                    return popupUrl;
                  });
              setRedirectResponseUrl(function (param) {
                    return redirectResponseUrl;
                  });
              return setloader(function (param) {
                          return false;
                        });
            }
            catch (raw_err){
              var err = Caml_js_exceptions.internalToOCamlException(raw_err);
              var exceptionMessage = JSON.stringify(Utils$OrcaPaymentPage.formatException(err));
              loggerState.setLogError(exceptionMessage, "THREE_DS_POPUP_REDIRECTION", undefined, undefined, undefined, undefined, undefined);
              return Utils$OrcaPaymentPage.postFailedSubmitResponse("error", "Something went wrong.");
            }
          };
          window.addEventListener("message", handle);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), []);
  return React.createElement(Modal$OrcaPaymentPage.make, {
              children: React.createElement("div", {
                    className: "w-full h-[500px] bg-white"
                  }, React.createElement("iframe", {
                        className: "w-full h-full",
                        src: match[0]
                      })),
              closeCallback: handleOnClose,
              loader: match$3[0],
              setOpenModal: match$2[1],
              openModal: match$2[0]
            });
}

var make = ThreeDSRedirectionModal;

export {
  make ,
}
/* react Not a pure module */
